<template>
    <div>
        <div class='container-fluid bannerimg'>
           <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Bannerimg'
}
</script>
